export const getLicenseKey = () => "";
